// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ghfj","questions":"styles_questions__1WPEs","footer":"styles_footer__Ig9Nq"};